<template>
<div>
  <div v-if="myAnswer.isCorrect" class="columns is-centered is-mobile">
    <div class="column is-narrow">
      <span class="icon has-text-success">
        <i class="fas fa-laugh-beam fa-3x"></i>
      </span>
    </div>
    <div class="column is-narrow">
      <strong>
        Correct Answer!
      </strong>
    </div>
  </div>
  <div v-else class="columns is-centered is-mobile">
    <div class="column is-narrow">
      <span class="icon has-text-danger">
        <i class="fas fa-sad-tear fa-3x"></i>
      </span>
    </div>
    <div class="column is-narrow">
      <strong>
        Sorry! Incorrect Answer.
      </strong>
    </div>
  </div>
  <div class="columns is-multiline">
    <div v-for="item in choices" :key="item.key" class="column is-6">
      <button
        :disabled="myAnswer.choice !== item.key && correctAnswer !== item.key"
        :class="{
          'is-outlined': myAnswer.choice !== item.key,
          'is-success': myAnswer.choice === item.key && myAnswer.isCorrect,
          'is-danger': myAnswer.choice === item.key && !myAnswer.isCorrect,
          'is-success': correctAnswer === item.key,
        }"
        class="answer-btn button is-primary is-rounded is-large is-fullwidth is-active">
        <span class="icon">
          {{item.key}}
        </span>
        <span>
          {{item.choice}}
        </span>
      </button>
    </div>
  </div> 
</div>
</template>

<script>
export default {
  name: 'ub-question-result',
  props: [
    'question',
  ],
  data() {
    return {
    };
  },
  computed: {
    user() {
      return this.$store.getters['user/dbUser'];
    },
    choices() {
      const keys = Object.keys(this.question.data.choices);
      const choices = [];
      keys.forEach((key) => {
        choices.push({
          key,
          choice: this.question.data.choices[key],
        });
      });
      return choices.sort((a, b) => {
        if(a.key < b.key) { return -1; }
        if(a.key > b.key) { return 1; }
        return 0;
      });
    },
    myAnswer() {
      const { answers } = this.question.data;
      return answers.find(a => a.userId === this.user.id);
    },
    correctAnswer() {
      return this.question.data.answer;
    },
    discardedAnswer() {

    }
  },
  methods: {
  },
  mounted() {
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>
.answer-btn{
  justify-content: flex-start;
  .icon{
    font-weight: bold;
  }
}
</style>
